
import { env } from '@env';
import { HttpRequestData, httpUtil, PaginationResponse } from '@/framework';

export interface GetRevenueOfPaymentMethodDetailRequest extends HttpRequestData {
    readonly query: {
        readonly salonId: number;
        readonly paymentMethodId: number;
        readonly startDate: string;
        readonly endDate: string;
    }
}

export interface GetRevenueOfPaymentMethodDetailResponse  {
    readonly totalRevenue?: number;
    readonly totalQuantity?: number;
    readonly salonBranchId?: number;
}

export const getRevenueOfPaymentMethodDetail = httpUtil.createHttpRequestMeta<
GetRevenueOfPaymentMethodDetailRequest,
    PaginationResponse<GetRevenueOfPaymentMethodDetailResponse>
>({
    baseUrl: env.orgServer,
    path: '/revenues/payment-method-detail',
    method: 'GET',
    authentication: 'bearer'
});
